// @flow
import React, { useContext } from 'react';
import { PaddedAndRaisedSegment } from '@presentational/PaddedAndRaisedSegment';
import { Grid } from 'semantic-ui-react';
import { StyledGridRow } from '@src/common-utils/styledComponents';
import { GenericSaveResetButtons } from '@components/GenericSaveResetButtons';
import { useUpdateSPDefaultCommitDetailsMutation } from '@streaming-projects/service-definitions/streamingProjectsApi';
import { Spacer } from '@presentational/spacing/Spacer';
import { SPOrgContext } from '@streaming-projects/orgs/contexts/SPOrgContext';
import { BACKEND_FIELDNAMES } from '@streaming-projects/enums';
import {
  CNBC_CONFIG,
  SP_DEFAULT_COMMIT_DETAILS_CONFIG,
} from '@streaming-projects/default-commit-details/config';
import { useSPDefaultCommitDetailsContext } from '@streaming-projects/default-commit-details/context/SPDefaultCommitDetailsContext';
import { If } from '@presentational/If';
import { IS_CNBC_SECTION_LIVE } from '@streaming-projects/constants';
import { SPDefaultCommitCreditsAndBurstsEnabledContainer } from '@streaming-projects/credits-and-bursts/SPDefaultCommitCreditsAndBurstsEnabledContainer';
import useDoesUserHaveEarlyAccess from '@streaming-projects/useDoesUserHaveEarlyAccess';

import SPDefaultCommitNameContainer from './fields/SPDefaultCommitNameContainer';
import SPDefaultCommitDealStartDateContainer from './fields/SPDefaultCommitDealStartDateContainer';
import SPDefaultCommitDealEndDateContainer from './fields/SPDefaultCommitDealEndDateContainer';
import SPDefaultCommitSupportTierContainer from './fields/SPDefaultCommitSupportTierContainer';

const SPDefaultCommitGenericDetails = () => {
  const spOrgContext = useContext(SPOrgContext);
  const [updateSPDefaultCommitDetails] = useUpdateSPDefaultCommitDetailsMutation();
  const spDefaultCommitDetails = useSPDefaultCommitDetailsContext();
  const doesUserHaveEarlyAccess = useDoesUserHaveEarlyAccess();

  let columnConfigToUse = [...SP_DEFAULT_COMMIT_DETAILS_CONFIG];
  if (doesUserHaveEarlyAccess && IS_CNBC_SECTION_LIVE) {
    columnConfigToUse = [...columnConfigToUse, CNBC_CONFIG];
  }

  const handleSave = async (payload) => {
    return await updateSPDefaultCommitDetails({
      orgId: spOrgContext.org.id,
      payload: {
        support_tier: payload.support_tier,
        cnbc_enabled: Boolean(payload.cnbc_enabled),
        Version: spDefaultCommitDetails?.version,
      },
    });
  };

  return (
    <PaddedAndRaisedSegment>
      <Grid columns={4}>
        <StyledGridRow coloumns={1}>
          <Grid.Column>
            <SPDefaultCommitNameContainer />
          </Grid.Column>
        </StyledGridRow>

        <StyledGridRow coloumns={3}>
          <Grid.Column>
            <SPDefaultCommitDealStartDateContainer />
          </Grid.Column>

          <Grid.Column>
            <SPDefaultCommitDealEndDateContainer />
          </Grid.Column>

          <Grid.Column>
            <SPDefaultCommitSupportTierContainer />
          </Grid.Column>
        </StyledGridRow>

        <If test={IS_CNBC_SECTION_LIVE && doesUserHaveEarlyAccess}>
          <StyledGridRow columns={4}>
            <Grid.Column>
              <SPDefaultCommitCreditsAndBurstsEnabledContainer />
            </Grid.Column>
          </StyledGridRow>
        </If>
      </Grid>

      <Spacer y={40} />

      <GenericSaveResetButtons
        fieldsConfig={columnConfigToUse.filter(
          (config) => config.backendFieldName !== BACKEND_FIELDNAMES.COMMIT_AMOUNT
        )}
        onSaveHandler={handleSave}
      />
    </PaddedAndRaisedSegment>
  );
};

export default SPDefaultCommitGenericDetails;
